import { TDShape } from "@psi/tldraw";

// Store the last shape state so that we can detect changes and prevent spamming the host
let LAST_STATE: TDShape[] = [];

export const getLastState = () => {
  return LAST_STATE;
};

export const setLastState = (shapes: TDShape[]) => {
  LAST_STATE = shapes;
};
